export default __webpack_public_path__ + "static/media/1808.0b89817b.png";